import { Button } from "@blueprintjs/core";
import { store } from "../store";
import KeycloakManager from "../services/keycloak";
import { Link } from "react-router-dom";

export const Forbidden = () => {
  return (
    <div className="flex flex-col flex-1 items-center justify-center text-center bg-gray-50 px-4 h-100">
      <h1 className="text-6xl font-extrabold text-red-600 mb-4">403</h1>
      <h2 className="text-2xl font-semibold mb-2 text-gray-800">
        Access Denied
      </h2>
      <p className="text-gray-600 mb-6 max-w-md">
        You don't have permission to view this page. Please contact your
        administrator if you believe this is a mistake.
      </p>
      <div className="flex flex-col gap-4">
        <Link
          to="/"
          className="px-5 py-2 rounded-2xl bg-blue-600 text-white font-medium hover:bg-blue-700 transition-colors"
        >
          Go back to Home
        </Link>

        <Button
          icon="log-out"
          intent="danger"
          text="Logout"
          onClick={() => KeycloakManager.doLogout(store.dispatch)}
        />
      </div>
    </div>
  );
};
